<template>
  <reference-filter :label="label" :count="count">
    <div v-for="option in options" :key="option.value">
      <v-checkbox
        :value="selectedValues.includes(option.value)"
        color="primary"
        hide-details
        class="mt-0"
        @change="onChange(option.value, $event)"
      >
        <template #label>
          <span class="text-body-2">{{ option.label }}</span>
        </template>
      </v-checkbox>
    </div>
  </reference-filter>
</template>

<script>
import ReferenceFilter from './ReferenceFilter';

export default {
  name: 'ReferenceFilterMultipleSelect',
  components: { ReferenceFilter },
  props: {
    selectedValues: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
      validator: (options) =>
        options.every(
          (option) =>
            typeof option === 'object' &&
            typeof option.label === 'string' &&
            typeof option.value === 'string'
        ),
    },
  },
  emits: ['update:selectedValues'],
  computed: {
    count() {
      return this.selectedValues.length;
    },
  },
  methods: {
    onChange(value, checked) {
      const selectedValues = [...this.selectedValues];
      if (checked) {
        selectedValues.push(value);
      } else {
        selectedValues.splice(selectedValues.indexOf(value), 1);
      }
      this.$emit(
        'update:selectedValues',
        selectedValues.length === 0 ? undefined : selectedValues
      );
    },
  },
};
</script>
